(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["card-atc-sizes"] && !Shopify.designMode) return;
  try {
    (function() {
    if (window.__cardAtcInit) return;
    window.__cardAtcInit = true;

    function refreshCart() {
      window.dispatchEvent(new Event('cart:refresh'));
      fetch('/cart.js').then(function(r) { return r.json(); }).then(function(cart) {
        var el = document.querySelector('.cart-count, [data-cart-count]');
        if (el) el.textContent = cart.item_count;
      });
    }

    function addToCart(variantId, btn, onDone) {
      if (!variantId) return;
      btn.disabled = true;

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: parseInt(variantId), quantity: 1 })
      })
      .then(function(r) { return r.json(); })
      .then(function() {
        refreshCart();
        if (onDone) onDone(true);
      })
      .catch(function() {
        if (onDone) onDone(false);
      });
    }

    document.addEventListener('click', function(e) {
      /* Size button — add to cart immediately */
      var sizeBtn = e.target.closest('.card-atc__size');
      if (sizeBtn && !sizeBtn.disabled) {
        e.preventDefault();
        e.stopPropagation();
        var wrap = sizeBtn.closest('.card-atc');
        var origText = sizeBtn.textContent.trim();

        wrap.querySelectorAll('.card-atc__size--active').forEach(function(b) {
          b.classList.remove('card-atc__size--active');
        });
        sizeBtn.classList.add('card-atc__size--active');
        sizeBtn.textContent = '...';

        addToCart(sizeBtn.dataset.variantId, sizeBtn, function(ok) {
          sizeBtn.textContent = ok ? '\u2713' : origText;
          if (ok) sizeBtn.classList.add('card-atc__size--added');
          setTimeout(function() {
            sizeBtn.textContent = origText;
            sizeBtn.classList.remove('card-atc__size--active', 'card-atc__size--added');
            sizeBtn.disabled = false;
          }, 1200);
        });
        return;
      }

      /* ATC Button (only for products WITHOUT sizes) */
      var atcBtn = e.target.closest('.card-atc__btn');
      if (atcBtn && !atcBtn.disabled) {
        e.preventDefault();
        e.stopPropagation();

        atcBtn.classList.add('card-atc__btn--loading');

        addToCart(atcBtn.dataset.variantId, atcBtn, function(ok) {
          atcBtn.classList.remove('card-atc__btn--loading');
          if (ok) {
            atcBtn.classList.add('card-atc__btn--added');
            atcBtn.querySelector('.card-atc__btn-text').textContent = 'AGREGADO';
          } else {
            atcBtn.querySelector('.card-atc__btn-text').textContent = 'ERROR';
          }
          setTimeout(function() {
            atcBtn.classList.remove('card-atc__btn--added');
            atcBtn.querySelector('.card-atc__btn-text').textContent = 'AGREGAR AL CARRITO';
            atcBtn.disabled = false;
          }, 1500);
        });
      }
    });

    /* Move card-atc inside the gallery */
    function moveSizesToGallery() {
      document.querySelectorAll('.card-atc:not([data-moved])').forEach(function(atc) {
        var card = atc.closest('product-card') || atc.closest('.product-card');
        if (!card) return;
        var gallery = card.querySelector('.card-gallery');
        if (gallery) {
          gallery.style.position = 'relative';
          gallery.appendChild(atc);
          atc.dataset.moved = '1';
        }
      });
    }
    /* Debounce: el observer escucha TODO el <body>, asi que sin esto
       moveSizesToGallery corria en cada mutacion del DOM (lazy images,
       refresh de carrito...). Con requestAnimationFrame las
       rafagas de mutaciones colapsan a una sola llamada por frame. */
    var moveScheduled = false;
    function scheduleMoveSizes() {
      if (moveScheduled) return;
      moveScheduled = true;
      requestAnimationFrame(function() {
        moveScheduled = false;
        moveSizesToGallery();
      });
    }
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', moveSizesToGallery);
    } else {
      moveSizesToGallery();
    }
    new MutationObserver(scheduleMoveSizes).observe(document.body, { childList: true, subtree: true });
  })();
  } catch(e) { console.error(e); }
})();

})();
